define('views/app',["exports", "underscore", "backbone", "./header", "./menu", "common", "jquery-ex"], function (_exports, _underscore, _backbone, _header, _menu, _common, _jqueryEx) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _header = _interopRequireDefault(_header);
  _menu = _interopRequireDefault(_menu);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var AppState = _backbone.Model.extend({});
  var _default = _exports.default = _backbone.View.extend({
    el: 'body',
    events: {},
    run() {
      var _query$get,
        _rootEl$dataset$lcNum,
        _rootEl$dataset$lcDat,
        _this = this;
      var rootEl = document.documentElement;
      var query = new URLSearchParams(location.search);
      this.currencyDefault = rootEl.dataset.currencyDefault;
      this.state = new AppState({
        currency: (_query$get = query.get('currency')) !== null && _query$get !== void 0 ? _query$get : rootEl.dataset.currency
      });
      this.pages = [];
      this.state.on('change:currency', (m, currency) => {
        var _iterator = _createForOfIteratorHelper(this.pages),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pageView = _step.value;
            if ((0, _underscore.isFunction)(pageView.currency)) {
              pageView.currency(currency);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.state.on('change:user', (m, user) => {
        this.header.setUser(user);
        this.menu.setUser(user);
        var _iterator2 = _createForOfIteratorHelper(this.pages),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var pageView = _step2.value;
            if ((0, _underscore.isFunction)(pageView.user)) {
              pageView.user(user);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
      this.lang = rootEl.lang;
      this.lcNumeric = (_rootEl$dataset$lcNum = rootEl.dataset.lcNumeric) !== null && _rootEl$dataset$lcNum !== void 0 ? _rootEl$dataset$lcNum : this.lang;
      this.lcDate = (_rootEl$dataset$lcDat = rootEl.dataset.lcDate) !== null && _rootEl$dataset$lcDat !== void 0 ? _rootEl$dataset$lcDat : this.lang;
      this.headerEl = this.el.querySelector('.b-header');
      this.header = new _header.default({
        el: this.headerEl
      });
      this.menu = new _menu.default({
        el: this.el.querySelector('#modal-menu')
      });
      var _iterator3 = _createForOfIteratorHelper(this.el.querySelectorAll('[data-page]')),
        _step3;
      try {
        var _loop = function _loop() {
          var page = _step3.value;
          if (page.dataset.page) {
            require([`pages/${page.dataset.page}`], ({
              default: PageView
            }) => {
              var pageView = new PageView({
                el: page
              });
              _this.pages.push(pageView);
              if (pageView.shown) {
                pageView.shown();
              }
            });
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    currency(value, on) {
      var type = typeof value;
      if (type === 'string') {
        return this.state.set('currency', value);
      } else if (type === 'function') {
        if (on === false) {
          this.state.off('change:currency', value);
        } else {
          this.state.on('change:currency', value);
        }
      } else {
        return this.state.get('currency');
      }
    },
    async login(email, password) {
      var user = await (0, _common.postJSON)('/login', {
        email,
        password
      });
      if (user.role === 'manager') {
        location.href = user.url;
        return undefined;
      } else {
        this.state.set('user', user);
        return user;
      }
    },
    profile() {
      return (0, _common.getJSON)('/profile');
    },
    async logout() {
      try {
        var user = await (0, _common.postJSON)('/logout', {});
        this.state.set('user', user);
        return user;
      } catch (error) {
        if (error.code === 403) {
          location.href = '/';
        }
        throw error;
      }
    },
    async signup(name, email, password) {
      var user = await (0, _common.postJSON)('/signup', {
        name,
        email,
        password
      });
      this.state.set('user', user);
      return user;
    }
  });
});//# sourceMappingURL=app.js.map
;
